module.exports = __webpack_public_path__ + "img/bg-download.4ce8712e.jpg";